export const setGameId = (state, id) => {
  state.gameId = id;
};
